"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _string = require("lodash/string");

var _all = require("animations-json/build/all");

var _LottieAnimationTrustPilotBase = _interopRequireDefault(require("../../LottieAnimationTrustPilotBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AnimationTrustPilot01 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(AnimationTrustPilot01, _AnimationBase);

  var _super = _createSuper(AnimationTrustPilot01);

  function AnimationTrustPilot01(animObj) {
    var _this;

    _classCallCheck(this, AnimationTrustPilot01);

    var animationId = animObj.animationId,
        data = animObj.data;
    var config = {
      default: {
        colors: ['#012D54']
      },
      inputs: [{
        key: 'title',
        type: 'string',
        dataPath: 'title',
        textTransform: 'none',
        maxLine: 1,
        maxCharInline: 33
      }, {
        key: 'text',
        type: 'string',
        dataPath: 'text',
        textTransform: 'none',
        maxLine: 3,
        maxCharInline: 50
      }, {
        key: 'customer_name',
        type: 'string',
        dataPath: 'consumer.displayName',
        textTransform: 'capitalize',
        maxLine: 1,
        maxCharInline: 1000
      }, {
        key: 'date',
        type: 'date',
        dataPath: 'createdAt',
        format: 'mmm d, yyyy'
      }, {
        key: 'stars',
        dataPath: 'stars',
        type: 'number'
      }],
      lineHeight: {
        base: 335,
        extra: 30
      },
      width: 660,
      height: 500,
      textShadow: false,
      inDuration: 1500,
      intermissionDuration: 3000,
      outDuration: 1500,
      totalDuration: 6000
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId);
    config.inputs.forEach(function (input) {
      var key = input.key;
      var pattern = new RegExp("{#".concat((0, _string.toUpper)(key), "#}"), 'g');
      var value = _this.inputsData.hasOwnProperty(key) ? _this.inputsData[key] : '';
      animation = animation.replace(pattern, value);
    }); // parse string to object

    _this.json = JSON.parse(animation);
    return _this;
  }

  return AnimationTrustPilot01;
}(_LottieAnimationTrustPilotBase.default);

exports.default = AnimationTrustPilot01;